export enum StrategyE {
  ALL_AGENTS = 'all_agents',
  AGENTS_MORE_TIME_WITHOUT_RECEIVING_SERVICE = 'assign_agents_more_time_without_receiving_service',
  AGENTS_WITH_LEAST_CALL_CLOSED = 'agents_with_least_call_closed',
  AGENTS_RANDOMLY = 'agents_randomly',
  AGENTS_REMEMBERING_LAST_ONE_YOU_RECEIVED = 'agents_remembering_last_one_you_received',
  AGENTS_BY_ORDER = 'agents_by_order',
}
